import React from 'react';
import '../css/Navigation.scss';
import { History, HistoryEvent } from '../router/History';
import Router from '../router/Router';
import { HeaderLogo, MenuLogo } from './Vectors';
import Button from './Button';
import Link from '../css/ui/Link';

export default class Navigation extends React.Component<{data:any}>
{

	container:HTMLDivElement;
	history = new History();

	_updateTimeout1;
	_updateTimeout2;
	_updateTimeout3;

	private _historyChange = () => {
		document.body.classList.remove('menu-open');
		if(this.container)
		{
			let els = this.container.querySelectorAll('li[data-path]');
			els.forEach((e)=>{
				e.classList.toggle('selected', e.matches('[data-path="'+this.history.path+'"]'));
			});
		}
	}

	componentDidMount()
	{
		this.history.on(HistoryEvent.CHANGE, this._historyChange);
		this.history.on(HistoryEvent.REPLACE, this._historyChange);
		this._historyChange();

		window.addEventListener('resize', this._resize);
		this._resize();
		this._updateTimeout1 = setTimeout(this._resize, 100);
		this._updateTimeout2 = setTimeout(this._resize, 1000);
		this._updateTimeout3 = setTimeout(this._resize, 2000);
		this.container.addEventListener('mouseenter', this._resize);
	}

	componentWillUnmount()
	{
		clearTimeout(this._updateTimeout1);
		clearTimeout(this._updateTimeout2);
		clearTimeout(this._updateTimeout3);
		window.removeEventListener('resize', this._resize);
		this.container.removeEventListener('mouseenter', this._resize);
	}

	private _resize = () =>
	{
		let items = this.container.querySelectorAll('.menu-item');
		items.forEach((item, i) => {
			let pb = item.getBoundingClientRect();
			let b = item.querySelector('.label').getBoundingClientRect();
			let over:HTMLElement = item.querySelector('.over');
			over.style['width'] = b.width + 'px';
			over.style['top'] = (b.top - pb.top) + b.height + 3 + 'px';
			over.style['left'] = (b.left - pb.left) + 'px';
			// console.log(item.querySelector('.label').innerHTML, item.querySelector('.label').getBoundingClientRect());
		});
	}

	toggleMenu = () =>
	{
		document.body.classList.toggle('menu-open');
	}

	private _buildNavigation(menuData:any): React.ReactNode {
		let items = menuData.map((e, i) => {
			let route = Router.getByID(e['link']);
			let children;
			if(e.items) children = this._buildNavigation(e.items);
			if(route)
			{
				let selected = (this.history.path == route)?'selected':null;
				return (<li key={i} data-path={route} className={selected}><Link key={i + '_link'} to={route}><span className='menu-item'><span className='over'></span><span className='label'>{e.label}</span></span></Link>{children}</li>);
			}
		});

		return (<ul className='menu'>{items}</ul>);
	}

	render()
	{
		return (
			<div ref={r => this.container = r} className='navigation'>
				<div className="logo navlogo">
					<Link to='home'>
						<HeaderLogo></HeaderLogo>
					</Link>
				</div>
				<div className="links">
					<div onClick={this.toggleMenu} className='show-small hamburger'>
						<div className='bar bar1'></div>
						<div className='bar bar2'></div>
					</div>
					<div className="linkItems">
						<Link to='home'>
							<MenuLogo className='show-small logo'></MenuLogo>
						</Link>
						{this._buildNavigation(this.props.data)}
					</div>
				</div>
			</div>
		);
	}
}
